var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94878 28H31.0511C34.3697 28 36 26.3868 36 23.1605V4.83951C36 1.61318 34.3697 0 31.0511 0H4.94878C1.64959 0 0 1.61318 0 4.83951V23.1605C0 26.3868 1.64959 28 4.94878 28ZM4.98761 25.2154C3.59028 25.2154 2.79461 24.4664 2.79461 23.026V4.97394C2.79461 3.51442 3.59028 2.78464 4.98761 2.78464H31.0123C32.4096 2.78464 33.2053 3.51442 33.2053 4.97394V23.026C33.2053 24.4664 32.4096 25.2154 31.0123 25.2154H4.98761ZM26.0247 13.8848C28.0236 13.8848 29.6538 12.2716 29.6538 10.2744C29.6538 8.27708 28.0236 6.66394 26.0247 6.66394C24.0064 6.66394 22.3762 8.27708 22.3762 10.2744C22.3762 12.2716 24.0064 13.8848 26.0247 13.8848ZM7.52989 9.52539H17.0781C17.7574 9.52539 18.2814 8.98767 18.2814 8.31551C18.2814 7.64335 17.7574 7.12485 17.0781 7.12485H7.52989C6.83124 7.12485 6.32667 7.64335 6.32667 8.31551C6.32667 8.98767 6.83124 9.52539 7.52989 9.52539ZM7.52989 13.6543H14.497C15.1762 13.6543 15.7196 13.1358 15.7196 12.4637C15.7196 11.7915 15.1762 11.2538 14.497 11.2538H7.52989C6.83124 11.2538 6.32667 11.7915 6.32667 12.4637C6.32667 13.1358 6.83124 13.6543 7.52989 13.6543Z",
    fill: "#3D4863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCard);
export default __webpack_public_path__ + "static/media/StudentCard.56a6fbf77f8b7441f3ee3eaaf04eb158.svg";
export { ForwardRef as ReactComponent };